import { SimpleLabel } from '@hopskipdrive/react-components';

export const SharedBillingLabelLegacy = ({
  residenceAccountId,
  attendingAccountId,
  riderAccountId,
}: {
  residenceAccountId: number;
  attendingAccountId: number;
  riderAccountId: number;
}) => {
  const isAttending = attendingAccountId === riderAccountId && 'Attending';
  const isResidence = residenceAccountId === riderAccountId && 'Residence';

  return (
    <SimpleLabel
      label={`Shared Rider: Viewing as ${isAttending || isResidence || ''} District`}
      textColor="white"
      bgColor="info-main"
    />
  );
};
